<template>
    <div>
        <div v-for="position in fingerfood" :key="position.id">
            <fingerfood-item
                    :id="position.id"
                    :title="position.title"
                    :subscription="position.subscription"
                    :coverImage="position.image"
                    :priceSmall="position.prices.small"
                    :priceLarge="position.prices.large"
                    :category="position.category"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import FingerfoodItem from "./fingerfoodItem";

    export default {
        components: {FingerfoodItem},
        created: function () {
            this.$store.dispatch('fetchFingerfood');
        },
        computed: {
            ...mapGetters(['fingerfood'])
        }
    }
</script>

<style scoped>

</style>